// src/App.js
import React from 'react';
import { 
  createBrowserRouter, 
  RouterProvider, 
  Route, 
  createRoutesFromElements 
} from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Login from './components/Login';
import Signup from './components/Signup';
import ProductivityApp from './ProductivityApp';
import PrivateRoute from './components/PrivateRoute';

function App() {
    // Create router using the new v7 approach
    const router = createBrowserRouter(
      createRoutesFromElements(
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <ProductivityApp />
              </PrivateRoute>
            }
          />
        </>
      )
    );

    return (
        <AuthProvider>
            <RouterProvider router={router} />
        </AuthProvider>
    );
}

export default App;